import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
	selector: 'ac-carousel',
	templateUrl: './carousel.component.html',
	styleUrls: ['./carousel.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CarouselComponent implements AfterViewInit {
	@Input('carouselItemTemplate') public template: TemplateRef<any>;
	@Input('data') public data: any[] = [];
	@Input('defaultCardsToShow') public cardsToShow: number = 3;

	@ViewChild('carousel') public carousel: ElementRef;

	public stackedCardsCount: number = 0;
	public cards: HTMLElement[] = [];

	public cardWidth: number = 0;
	private readonly stackedCardOffset: number = 16;

	constructor(private cdRef: ChangeDetectorRef) {}

	public ngAfterViewInit(): void {
		this.cards = this.carousel.nativeElement.children;
		this.setupNumberOfCardsToShow(this.carousel.nativeElement.clientWidth);
		this.cdRef.detectChanges();
	}

	public onLeft(): void {
		this.stackedCardsCount--;
		this.stackCards(this.stackedCardsCount);
	}

	public onRight(): void {
		this.stackedCardsCount++;
		this.stackCards(this.stackedCardsCount);
	}

	public shouldDisableLeft(): boolean {
		return this.stackedCardsCount <= 0;
	}

	public shouldDisableRight(): boolean {
		return this.stackedCardsCount >= this.cards.length - this.cardsToShow;
	}

	private stackCards(count: number): void {
		for (let i = count; i < this.cards.length; i++) {
			this.cards[i].style.left = `-${this.cardWidth * count - count * this.stackedCardOffset}px`;
		}
	}

	public onSwipeLeft(): void {
		if (!this.shouldDisableRight()) {
			this.onRight();
		}
	}

	public onSwipeRight(): void {
		if (!this.shouldDisableLeft()) {
			this.onLeft();
		}
	}

	public onCarouselResize(): void {
		this.setupNumberOfCardsToShow(this.carousel.nativeElement.clientWidth);
		this.adjustCardsOnResize();
	}

	private setupNumberOfCardsToShow(viewportSize: number): void {
		this.cardWidth = this.cards[0].clientWidth;
		this.cardsToShow = Math.floor(viewportSize / this.cardWidth);
	}

	private adjustCardsOnResize(): void {
		const maxCardsToShowOnResize = this.cards.length - this.cardsToShow;
		if (this.stackedCardsCount > maxCardsToShowOnResize && maxCardsToShowOnResize >= 0) {
			this.stackedCardsCount = maxCardsToShowOnResize;
		}
		for (let i = 0; i <= this.stackedCardsCount; i++) {
			this.stackCards(i);
		}
	}
}
